import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../services/api/axios-client";

export const useNotificationsQuery = () => {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      return api
        .notificationsControllerFindUserNotifications()
        .then((result) => result.data);
    },
  });
};

export const useUpdateSeenAtMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (uploadId: number) => {
      return api.notificationsControllerUpdateSeen({
        uploadId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
      });
    },
  });
};
